import { render } from "./RemoveAgentPopup.vue?vue&type=template&id=15eabefc"
import script from "./RemoveAgentPopup.vue?vue&type=script&lang=js"
export * from "./RemoveAgentPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__